import { tryGetFeedsContent, tryGetBackgroundTaskStatus, invalidateFeedsCache, getRotationalPreviewIds, getCurrentDefaultPreviewContent, getCurrentPreviewInTaskbar, getCurrentFeedsServiceActivityID, getTaskbarSettingChangedInfo, isCurrentFeedsStaticFallback, refreshFeedsContentAsync } from "../../externalApi/FeedsApi";
// This implementation handles feeds cache module
export class WidgetShellFeeds {
    async tryGetFeedsContent() {
        return await tryGetFeedsContent();
    }
    async tryGetBackgroundTaskStatus() {
        return await tryGetBackgroundTaskStatus();
    }
    async invalidateFeedsCache() {
        return await invalidateFeedsCache();
    }
    async getRotationalPreviewIds() {
        const jsonString = await getRotationalPreviewIds();
        if (!jsonString) {
            return {};
        }
        return JSON.parse(jsonString);
    }
    async getCurrentDefaultPreviewContent() {
        return await getCurrentDefaultPreviewContent();
    }
    async getCurrentPreviewInTaskbar() {
        const jsonString = await getCurrentPreviewInTaskbar();
        if (!jsonString) {
            return {};
        }
        return JSON.parse(jsonString);
    }
    async getCurrentFeedsServiceActivityID() {
        return await getCurrentFeedsServiceActivityID();
    }
    async getTaskbarSettingChangedInfo() {
        return await getTaskbarSettingChangedInfo();
    }
    async isCurrentFeedsStaticFallback() {
        return await isCurrentFeedsStaticFallback();
    }
    async refreshFeedsContentAsync(verb, data) {
        return await new Promise(async (resolve, reject) => {
            try {
                await refreshFeedsContentAsync(verb, data, (status) => {
                    return resolve(status);
                });
            }
            catch (error) {
                reject(error);
            }
        });
    }
}
